import { createEventBus } from "@core/features/eventBus";
import type { VideoEvents } from "./video.types";

export const videoEventBus = createEventBus<VideoEvents>();
